/** True when a visitor is still checked in past their expected checkout time. */
export const isOverstaying = (invite: {
  currentStatus?: string;
  expectedCheckoutAt?: string;
}): boolean => {
  if (invite.currentStatus !== 'checked_in' || !invite.expectedCheckoutAt) {
    return false;
  }
  return new Date(invite.expectedCheckoutAt).getTime() < Date.now();
};
